import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import './content.scss';

//display card for cart item
function CartContentItem(props) {
  //props fetch data from "addcart" object from content.json
  const { title, url, image, buttonBG, buttonColor } = props.item;
  const img_path = `/images/${process.env.REACT_APP_BRAND_NAME}/${image}`;

  function trackAddToCartEvent (){
    window.gtag('event', 'addtocartclick', { 
      product: title
     });
  }

  return (
    <div className="cart-card">
      <div className='card-item'>
        <img src={img_path} className="card-img-top content-img" alt="" />
        <div className="card-title h6">{ReactHtmlParser(title)}</div>
        <button className="cart-btn" style={{ backgroundColor: buttonBG, color: buttonColor }}>
          <a 
            href={url} 
            onClick={trackAddToCartEvent} 
            target="_blank" 
            rel="noopener noreferrer"
          >Shop Now</a>
        </button>
      </div>
    </div>
  );
}
export default CartContentItem;
